import { AllHTMLAttributes, ChangeEvent, forwardRef, useCallback } from 'react';
import { FormControl, FormControlProps } from 'react-bootstrap';
import classNames from 'classnames';

import classes from './text-input.module.scss';

export type TextInputElement =
  | HTMLInputElement
  | HTMLSelectElement
  | HTMLTextAreaElement;

export type TextInputProps = AllHTMLAttributes<HTMLInputElement> &
  FormControlProps & {
    label?: string;
    onTextChange?: (text: string) => void;
  };

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ className, onChange, onTextChange, ...props }, ref) => {
    const onChangeCallback = useCallback(
      (event: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
          onChange(event);
        }

        if (onTextChange) {
          onTextChange(event.target.value);
        }
      },
      [onChange, onTextChange]
    );

    return (
      <FormControl
        {...props}
        className={classNames(classes.input, className)}
        onChange={onChangeCallback}
        ref={ref}
      />
    );
  }
);
